import { render, staticRenderFns } from "./PosScan.vue?vue&type=template&id=84b44928&scoped=true&"
import script from "./PosScan.vue?vue&type=script&lang=js&"
export * from "./PosScan.vue?vue&type=script&lang=js&"
import style0 from "./PosScan.vue?vue&type=style&index=0&id=84b44928&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b44928",
  null
  
)

export default component.exports